import React from 'react';
import BlogList from '../components/BlogList';
import EventsSection from '../components/EventsSection';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/DSC_0424.JPG";

const Events = () => {
const eventData = [
  {
    slug: "graduation-day-alumni-awards",
    title: "Graduation Day & Alumni Awards",
    date: "Sun, 02 Mar",
    location: "Bengaluru",
    description:
      "A special day marking the achievements and dedication of our graduates & alumni.",
    image:
      "https://static.wixstatic.com/media/6870b3_eab6db776b5c4c67920ec301bbb212ef~mv2.jpg"
  },
  {
    slug: "positive-parenting-workshop",
    title: "Positive Parenting Workshop",
    date: "Sat, 09 Dec",
    location: "Bengaluru",
    description: "Improve your understanding of your child. Learn tips & methods.",
    image:
      "https://static.wixstatic.com/media/6870b3_acaef89c412d4de18fe391423c03439c~mv2.png"
  },
  {
    slug: "free-pre-primary-teacher-training",
    title: "Free Pre-Primary Teacher Training",
    date: "Sat, 25 Nov",
    location: "Kushalnagar",
    description:
      "Workshop for Playgroup, Nursery, LKG, UKG teachers to learn effective tools.",
    image:
      "https://static.wixstatic.com/media/6870b3_e074678ce4704e69918582b1e316543f~mv2.jpg"
  }
];



  return (
    <>
       <UniqueBanner
  image={BannerImg}
  title="Montessori Teacher Training Near Me"
  subtitle="Stay updated with our latest workshops, seminars, and activities"
/>
    <EventsSection events={eventData} />;
    </>
  );
};

export default Events;
